module.exports = __webpack_public_path__ + "cb718e92.svg";